// get session constants
export const GET_SESSION_REQUEST = 'app/GET_SESSION_REQUEST';
export const GET_SESSION_SUCCESS = 'app/GET_SESSION_SUCCESS';
export const GET_SESSION_ERROR = 'app/GET_SESSION_ERROR';

// edit session constants
export const EDIT_SESSION_REQUEST = 'app/EDIT_SESSION_REQUEST';
export const BULK_EDIT_SESSION_REQUEST = 'app/BULK_EDIT_SESSION_REQUEST';
export const EDIT_SESSION_SUCCESS = 'app/EDIT_SESSION_SUCCESS';
export const EDIT_SESSION_ERROR = 'app/EDIT_SESSION_ERROR';
export const UPDATE_NARRATOR_SUCCESS = 'app/UPDATE_NARRATOR_SUCCESS';
